import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

export const getCrashGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/crash-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getAllGameSettingsService = () => {
  return axiosInstance(METHOD_TYPES.get, '/games/settings', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table
  })
}

export const getDiceGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/dice-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getPlinkoGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/plinko-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getKenoGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/keno-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getVideoPokerGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/video-poker-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getHiloGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/hilo-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getBlackjackGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/blackjack-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getLimboGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/limbo-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getMinesGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/mines-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getRouletteGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/roulette-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getCoinFlipGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/coin-flip-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getMultiCrashGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/crash-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getChopperCrashGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/crash-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getSoccerCrashGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/crash-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getPyramidPlinkoGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/plinko-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getGongaMineGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/mines-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getSpaceDiceGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/space-dice-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}
export const getTowerGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/tower-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}
export const getCrossGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/cross-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}
